import { useEffect, useState } from "react";
import ClientSidebarLinks from "./ClientSidebarLinks";
import { useAuth } from "../../context/AuthContext";

const ProjectTeam = () => {
  const { user } = useAuth();
  const [team, setTeam] = useState<any[]>([]);

  useEffect(() => {
    if (user?.id) {
      fetch(
        `${API_BASE}/get_project_team.php?user_id=${user.id}`
      )
        .then((res) => res.json())
        .then((data) => setTeam(data))
        .catch((err) => console.error(err));
    }
  }, [user]);

  return (
    <>
      <style>{`
        * {
          box-sizing: border-box;
          font-family: Arial, sans-serif;
        }

        body {
          margin: 0;
          background: #f6f8fb;
        }

        .layout {
          display: flex;
          min-height: 100vh;
        }

        /* Sidebar */
        .sidebar {
          width: 230px;
          background: #fff;
          padding: 20px;
          border-right: 1px solid #e5e7eb;
        }

        .contact-btn {
          width: 100%;
          background: #22c55e;
          color: white;
          border: none;
          padding: 10px;
          border-radius: 6px;
          cursor: pointer;
          margin-bottom: 20px;
        }

        .menu a {
          display: block;
          padding: 10px;
          color: #555;
          border-radius: 6px;
          text-decoration: none;
          margin-bottom: 6px;
          cursor: pointer;
        }

        .menu a.active {
          background: #eafaf0;
          color: #22c55e;
          font-weight: 600;
        }

        /* Content */
        .content {
          flex: 1;
          padding: 24px;
        }

        .header h2 {
          margin: 0;
        }

        .header p {
          color: #6b7280;
          margin-top: 4px;
        }

        /* Team Grid */
        .team-grid {
          margin-top: 20px;
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 16px;
        }

        .card {
          background: white;
          border-radius: 10px;
          padding: 16px;
          border: 1px solid #eee;
        }

        .card-header {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-bottom: 10px;
        }

        .avatar {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          background: #22c55e;
          color: white;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: bold;
        }

        .name {
          font-weight: 600;
        }

        .role {
          font-size: 13px;
          color: #6b7280;
        }

        .badge {
          margin-left: auto;
          background: #111827;
          color: white;
          font-size: 11px;
          padding: 4px 8px;
          border-radius: 6px;
        }

        .info {
          font-size: 13px;
          margin-top: 8px;
          display: flex;
          justify-content: space-between;
        }

        .info span {
          color: #6b7280;
        }

        .email {
          color: #22c55e;
          font-size: 13px;
          margin-top: 4px;
          word-break: break-all;
        }

        /* Floating buttons */
        .floating {
          position: fixed;
          right: 20px;
          bottom: 20px;
          display: flex;
          flex-direction: column;
          gap: 10px;
        }

        .fab {
          width: 44px;
          height: 44px;
          border-radius: 50%;
          border: none;
          color: white;
          cursor: pointer;
          font-size: 18px;
        }

        .green { background: #22c55e; }
        .blue { background: #3b82f6; }
        .red { background: #ef4444; }

        @media (max-width: 1100px) {
          .team-grid {
            grid-template-columns: repeat(2, 1fr);
          }
        }

        @media (max-width: 700px) {
          .sidebar {
            display: none;
          }
          .team-grid {
            grid-template-columns: 1fr;
          }
        }
      `}</style>

      <div className="layout">
        {/* Sidebar */}
        <aside className="sidebar">
          <button className="contact-btn">Contact Team</button>
          <div className="menu">
            <ClientSidebarLinks active="team" />
          </div>
        </aside>

        {/* Main */}
        <main className="content">
          <div className="header">
            <h2>Your Project Team</h2>
            <p>Meet the people working on your project</p>
          </div>

          <div className="team-grid">
            {team.length === 0 ? (
              <p className="text-gray-500">No team members assigned.</p>
            ) : (
              team.map((member, index) => (
                <div className="card" key={index}>
                  <div className="card-header">
                    <div className="avatar">{member.name ? member.name[0] : "?"}</div>
                    <div>
                      <div className="name">{member.name}</div>
                      <div className="role">{member.role}</div>
                    </div>
                    <div className="badge">{member.role}</div>
                  </div>

                  <div className="info">
                    <span>Allocation</span>
                    <strong>100%</strong>
                  </div>

                  <div className="info">
                    <span>Email</span>
                  </div>
                  <div className="email">{member.email}</div>
                </div>
              ))
            )}
          </div>
        </main>

        {/* Floating buttons */}
        <div className="floating">
          <button className="fab green">💬</button>
          <button className="fab blue">📞</button>
          <button className="fab red">✉️</button>
        </div>
      </div>
    </>
  );
};

const API_BASE = import.meta.env.VITE_API_BASE_URL || '/api';

export default ProjectTeam;
